module.exports = __webpack_public_path__ + "static/img/1_4_2.65f241d0.jpg";